import * as Yup from "yup";
import { form } from "./form";

const {
  formField: {
    endpointUrl,
    triggerName,
    description,
    parameters,
    notes
  },
} = form;

const paramItem = parameters.itemField;
const paramNameRegex = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;

const parameterValidation = Yup.object().shape({
  [paramItem.paramName.name]: Yup.string()
    .matches(paramNameRegex, paramItem.paramName.errorMsg)
    .required(paramItem.paramName.errorMsg),

  [paramItem.paramType.name]: Yup.string()
    .oneOf(
      ["string", "number", "boolean", "object", "array", "datetime"],
      paramItem.paramType.errorMsg
    )
    .required(paramItem.paramType.errorMsg),

  [paramItem.paramDescription.name]: Yup.string(),
});

const validations = Yup.object().shape({
  [endpointUrl.name]: Yup.string(),
  [triggerName.name]: Yup.string().required(triggerName.errorMsg),
  [description.name]: Yup.string().required(description.errorMsg),
  [parameters.name]: Yup.array().of(parameterValidation).nullable(),
  [notes.name]: Yup.string(),
});

export default validations;